<app-modal id="list-cards" [maskClose]="false">
  <aside class="modal">
    @if (loading) {
      <app-spinner></app-spinner>
    }
    <div class="modal-body" id="update-card-form-body">
      <div class="header">
        <div class="title-text">Payment methods</div>
        <div class="button regular close" (click)="cancel()"><span
        class="icon">&#x00D7;</span></div>
      </div>
      <div class="content">
        @for (card of listCards; track card) {
          <div class="card" [ngClass]="{'primary': card.id === customer.paymentMethodId}">
            <div class="container">
              <div class="card-info">
                <img ngClass="{{card.card.brand}}">
                <div>
                  <p class="titleCard">{{card.card.brand}} ending in {{card.card.last4}}</p>
                  <p>Expiry {{card.card.exp_month}}/{{card.card.exp_year}}</p>
                  <p class="mail"><img src="../../../assets/img/mail.png" alt=""> {{customer.email}}</p>
                </div>
              </div>
              <div class="card-buttons">
                @if (card.id !== customer.paymentMethodId) {
                  <a (click)="removeCard(card)"><img
                  src="../../../assets/img/trash.png" alt=""></a>
                }
                <div (click)="updatePrimaryCard(card)" class="selectPrimary" [class]="{disabled: listCards.length <= 1}">
                  <input [disabled]="listCards.length <= 1" type="checkbox" [checked]="card.id === customer.paymentMethodId">Primary payment method
                </div>
              </div>
            </div>
          </div>
        }
        <hr>
          <div class="buttons">
            <button class="regular button outline-green" (click)="addNewCard()">+ Card</button>
          </div>
        </div>
      </div>
    </aside>
    <div class="modal-background"></div>
  </app-modal>
  <app-add-card [author]="author" [cardSelected]="cardSelected" (emitRefreshListCards)="getCards($event)"
  [changeCard]="true" [currentSubscription]="currentSubscription"></app-add-card>
  <app-success-modal [modalId]="'success-removeCard'" (confirmChoice)="getCards(false)"
  [text]="successText"></app-success-modal>
  @if (listCards) {
    <app-confirm-modal [modalId]="'remove-Card'" [text]="confirmText" [buttonText]="buttonText"
    (confirmChoice)="comfirmRemoveCard($event)"></app-confirm-modal>
  }
